export default {
  label: 'Facturer les frais de service sur les commandes à table',
  description: 'Les commandes à table n’ont pas de frais de service, sauf si cette option est activée.',
  no_fee: "Votre restaurant ne facture pas de frais de service, les commandes à table n'en paient donc pas non plus.",
  partner_default_on: 'Par défaut du partenaire : activé',
  partner_default_off: 'Par défaut du partenaire : désactivé',
  toasts: {
    on: 'Les commandes à table paient désormais les frais de service',
    off: 'Les commandes à table ne paient désormais plus de frais de service',
    error: 'L’enregistrement a échoué. Veuillez réessayer.',
  },
};
